export default __webpack_public_path__ + "static/media/partner-web.b55db3a1.webp";